import { ShieldCheck, Scale } from 'lucide-react';
import { useI18n } from '../../hooks/useI18n';

interface PhotoPrivacyNoticeProps {
  consentGiven: boolean;
  onConsentChange: (v: boolean) => void;
}

export function PhotoPrivacyNotice({ consentGiven, onConsentChange }: PhotoPrivacyNoticeProps) {
  const { t } = useI18n();
  return (
    <div
      style={{
        backgroundColor: 'rgba(31,78,95,0.06)',
        border: '1px solid var(--border-gold)',
        borderRadius: 'var(--radius-card)',
        padding: '1.25rem',
        marginBottom: '1.5rem',
      }}
    >
      <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start', marginBottom: '1rem' }}>
        <ShieldCheck size={22} style={{ color: 'var(--petrol)', flexShrink: 0, marginTop: '0.1rem' }} />
        <div>
          <p style={{ fontWeight: 600, color: 'var(--text-primary)', margin: '0 0 0.35rem', fontSize: 'var(--text-label)' }}>
            {t('shared.privacyTitle')}
          </p>
          <p style={{ color: 'var(--text-secondary)', margin: 0, fontSize: 'var(--text-caption)', lineHeight: 1.6 }}>
            {t('shared.privacyDesc')}
          </p>
        </div>
      </div>

      {/* PM-05: LGPD third-party consent checkbox (required) */}
      <label style={{ display: 'flex', alignItems: 'flex-start', gap: '0.625rem', cursor: 'pointer', marginBottom: '1rem' }}>
        <input
          type="checkbox"
          checked={consentGiven}
          onChange={e => onConsentChange(e.target.checked)}
          style={{
            width: '20px',
            height: '20px',
            marginTop: '0.1rem',
            flexShrink: 0,
            accentColor: 'var(--petrol)',
            cursor: 'pointer',
          }}
        />
        <span style={{ fontSize: 'var(--text-label)', color: 'var(--text-secondary)', lineHeight: 1.5 }}>
          Confirmo que tenho o consentimento da pessoa na foto para que sua imagem seja analisada.
          Esta análise é para uso pessoal e privado.
        </span>
      </label>

      {/* PM-05: LGPD legal notice */}
      <div style={{
        display: 'flex',
        gap: '0.5rem',
        alignItems: 'flex-start',
        backgroundColor: 'rgba(245,200,66,0.04)',
        border: '1px solid rgba(245,200,66,0.15)',
        borderRadius: 'var(--radius-md)',
        padding: '0.75rem',
      }}>
        <Scale size={14} style={{ color: 'var(--text-muted)', flexShrink: 0, marginTop: '0.15rem' }} />
        <p style={{ color: 'var(--text-muted)', margin: 0, fontSize: 'var(--text-caption)', lineHeight: 1.6 }}>
          <strong style={{ color: 'var(--text-tertiary)' }}>Aviso legal:</strong> ao prosseguir, você confirma ter o consentimento explícito
          da pessoa fotografada para este processamento, conforme exigido pela{' '}
          <strong>LGPD (Lei nº 13.709/2018), Art. 11</strong>. O uso desta funcionalidade para analisar imagens
          sem consentimento viola a lei brasileira de proteção de dados.
        </p>
      </div>
    </div>
  );
}
